import { Profile } from 'oidc-client';
import { MatchDetailVm } from '../../../utils/api';
import MatchAdminEventActions from './MatchAdminEventActions';

interface OwnProps {
    match: MatchDetailVm;
    userProfile?: Profile;
    onCompleted?: () => void | Promise<void>;
    /** `menu` renders tiles for the match-log right panel. Default is the button row. */
    appearance?: 'buttons' | 'menu';
}

export type Props = OwnProps;

export default MatchAdminEventActions;
